var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Tabs from '@mui/material/Tabs';
import * as Preact from 'preact';
import * as Tab from './A_Tab';
export var Component = function (p) {
    var handleTabChange = function (event, newValue) {
        p.setTabValue(newValue);
        if (p.trackCompatibility)
            p.trackCompatibility(newValue);
    };
    if (p.tabs.length <= 0)
        return null;
    return (Preact.h(Tabs, { sx: __assign({ backgroundColor: 'background.paper' }, p.sx), variant: "fullWidth", value: p.activeTabValue, onChange: handleTabChange }, p.tabs.map(function (tab, index) { return (Preact.h(Tab.Component, { label: tab.tabLabel, disabled: tab.disabled, key: index, icon: tab.icon, iconPosition: tab.iconPosition, sx: { padding: '8px' } })); })));
};
Component.displayName = 'TabGroup';
